import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-video-iq-identity',
  templateUrl: './help-youtube-video-iq-identity.component.html'
})
export class HelpYoutubeVideoIqIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
